import React, { useEffect } from "react";
import "./blogContent.scss";
import Navbar from "../../../shared/navbar";
import Footer from "../../../shared/footer";

const BlogContent = () => {
  useEffect(() => {
    // Scroll to the top when the component mounts
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <div id="scrollTop" className="blogBannerWrapper">
        <div className="blogBanner">
          <div className="blogHeadingWrapper">
            <p>BLOGS</p>
          </div>
        </div>

        <div className="blogContentSection">
          <img
            className="blueprintLeft"
            src="/images/home/BlueprintLeft.png"
            alt="..."
          />

          <img
            className="blueprintRight"
            src="/images/home/BlueprintRight.png"
            alt="..."
          />

          <div className="blogContentContainer">
            <img src="/images/home/building.png" alt="..." />
            <div className="blogData">
              <p className="horizontal-line"></p>
              <h3 className="mainBlogHeading">Building Brilliance</h3>
              <span>
                Enter into a world where construction transcends into an art
                form our service embodies building brilliance. Each project is a
                symphony of innovation and precision, creating architectural
                poetry.
                <br />
                In the vast canvas of construction, where steel and concrete
                meet creativity and precision, Group LanDev AI invites you to
                embark on a journey into a realm where building becomes an art.
                Our commitment to building brilliance transforms each project
                into a living, breathing masterpiece a testament to innovation
                and precision that goes beyond the ordinary.
              </span>

              <h4>Streamlining Customer Interactions:"</h4>
              <span>
                One of the hallmarks of Group LanDev AI's success lies in its
                ability to simplify customer interactions. With a keen focus on
                leveraging artificial intelligence, they have transformed the
                cumbersome process of scheduling appointments into a seamless
                experience. Clients now have the convenience of effortlessly
                setting up meetings and consultations, fostering a smoother and
                more responsive communication channel. This commitment to
                enhancing customer experience marks a significant sOne of the
                hallmarks of Group LanDev AI's success lies in its ability to
                simplify customer interactions. With a keen focus on leveraging
                artificial intelligence, they have transformed the cumbersome
                process of scheduling appointments into a seamless experience.
                Clients now have the convenience of effortlessly setting up
                meetings and consultations, fostering a smoother and more
                responsive communication channel. This commitment to enhancing
                customer experience marks a significant stride towards a more
                client-centric construction industry.
              </span>
              <h4>Innovative Contract Procedures:</h4>
              <span>
                Group LanDev AI has not only streamlined customer interactions
                but has also revolutionized contract procedures. The once
                complex and time-consuming task of navigating through contracts
                has been simplified, thanks to LanDev AI's innovative use of
                technology. The introduction of intelligent contract systems has
                significantly reduced the time and effort required, allowing
                stakeholders to engage in more meaningful aspects of the
                construction process. This transformation underscores LanDev
                AI's dedication to efficiency and innovation in every facet of
                their work.
              </span>
              <h4>A Stage of Construction as a Creative Masterpiece:</h4>
              <span>
                For Group LanDev AI, construction is not just about erecting
                structures; it's about crafting a creative masterpiece. Every
                project undertaken by the group is infused with a unique blend
                of artistic vision and technical expertise. From
                conceptualization to completion, LanDev AI ensures that each
                stage of construction is approached as an opportunity for
                creativity. This commitment to excellence has not only earned
                them acclaim within the industry but has also set a new
                benchmark for what is possible in the world of construction.
                <br />
                Group LanDev AI's pursuit of excellence has not gone unnoticed.
                The construction industry has showered them with awards,
                recognizing their outstanding contributions to the field.
              </span>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogContent;
